import {API_DRIVER} from "../configs/axios";

const OrderItemService = {
    fetchInCorso: (query, cancelToken) => {
        return API_DRIVER.get(`/api/orderItems/inCorso${query}`, {
            cancelToken: cancelToken
        })
    },
    fetchConsegnati: (query, cancelToken) => {
        return API_DRIVER.get(`/api/orderItems/consegnati${query}`, {
            cancelToken: cancelToken
        })
    },
    fetchAnnullati: (query, cancelToken) => {
        return API_DRIVER.get(`/api/orderItems/annullati${query}`, {
            cancelToken: cancelToken
        })
    },
    fetchOrderDetails: (orderId, integrationId) => {
        return API_DRIVER.get(`/api/orderItems/${orderId}/customer/${integrationId}`)
    },
    downloadCsv: (orderType, query) => {
        return API_DRIVER(`/api/orderItems/${orderType}/csv${query}`, {
            responseType: 'blob'
        })
    },
    fetchFilterSuggestions: (query, cancelToken) => {
        return API_DRIVER.get(`/api/orderItems/autocomplete${query}`, {
            cancelToken: cancelToken
        })
    }
}

export default OrderItemService
